// Dynamic agent registry fed from GET /api/agents (SQLite is the source of truth).
const registry = new Map();

const FALLBACK_COLORS = ['#00ff88', '#00ddff', '#ff6b35', '#b388ff', '#ffd700', '#e74c3c', '#4dd0e1', '#aed581'];

/**
 * An agent's `avatar` column historically held an emoji; the UI now draws only
 * iq-ui Icons, so an emoji is translated to its closest Material Symbol and a
 * plain symbol name is passed through (that is what new agents store).
 */
const EMOJI_ICONS = {
  '🤖': 'smart_toy', '🎯': 'target', '⚙': 'settings', '💻': 'terminal',
  '🔍': 'search', '⚡': 'bolt', '🔬': 'biotech', '🧠': 'psychology',
  '📊': 'analytics', '🚀': 'rocket_launch', '📝': 'edit_note', '🛠': 'handyman',
};

export function agentIcon(avatar) {
  const raw = String(avatar || '').trim();
  if (/^[a-z][a-z0-9_]*$/.test(raw)) return raw;
  return EMOJI_ICONS[raw.replace(/\uFE0F/g, '')] || 'smart_toy';
}

function hashColor(id) {
  let h = 0;
  for (const ch of String(id)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return FALLBACK_COLORS[h % FALLBACK_COLORS.length];
}

export function setAgents(list) {
  registry.clear();
  for (const a of list || []) {
    registry.set(a.id, {
      id: a.id, name: a.name || a.id, icon: agentIcon(a.avatar),
      color: a.color || hashColor(a.id), description: a.description || '',
    });
  }
}

export function agentInfo(id) {
  if (id === 'system') return { id, name: 'System', icon: 'settings', color: '#888888' };
  return registry.get(id) || { id, name: id, icon: 'smart_toy', color: hashColor(id) };
}

export function allAgents() {
  return [...registry.values()];
}
